module.exports = __webpack_public_path__ + "images/FUSA_icons/027-payment-method-1.9a42c7518426b27f8256d5254e8217fa.svg";